import React from 'react'
import { Card } from 'primereact/card'

export default function CardsHistoricoLeitura({ cardInfos, finalizadoPorUser }) {
  return (
    <>
      {cardInfos.map(i => (
        <div key={i.title} className="p-col-12 p-md-6">
          <Card title={i.title}>
            {i.items.map(item => (
              <div key={item.title} style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>{item.title}</div>
                <div style={{ width: 150 }}>{item.value}</div>
              </div>
            ))}
          </Card>
        </div>
      ))}
      {finalizadoPorUser && (
        <div className="p-col-12">
          <Card title="Finalizado Por">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ flex: 1 }}>{finalizadoPorUser}</div>
            </div>
          </Card>
        </div>
      )}
    </>
  )
}
